var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relation-info-box clearfix"},[_c('develop-tree'),_c('relation-info-item')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }